import { api } from './client';

export interface Blacklist {
  id: number;
  guestName: string;
  guestPhone: string;
  reason?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateBlacklistDto {
  guestName: string;
  guestPhone: string;
  reason?: string;
}

export interface UpdateBlacklistDto {
  guestName?: string;
  guestPhone?: string;
  reason?: string;
  isActive?: boolean;
}

export const blacklistApi = {
  // 전체 블랙리스트 조회
  getAll: async (): Promise<Blacklist[]> => {
    const response = await api.get('/blacklist');
    return response.data.data;
  },

  // 활성 블랙리스트만 조회
  getActive: async (): Promise<Blacklist[]> => {
    const response = await api.get('/blacklist/active');
    return response.data.data;
  },

  // ID로 조회
  getById: async (id: number): Promise<Blacklist> => {
    const response = await api.get(`/blacklist/${id}`);
    return response.data.data;
  },

  // 전화번호로 블랙리스트 확인
  checkByPhone: async (phone: string): Promise<{ isBlacklisted: boolean; blacklist: Blacklist | null }> => {
    const response = await api.get(`/blacklist/check/${phone}`);
    return response.data.data;
  },

  // 블랙리스트 추가
  create: async (data: CreateBlacklistDto): Promise<Blacklist> => {
    const response = await api.post('/blacklist', data);
    return response.data.data;
  },

  // 블랙리스트 수정
  update: async (id: number, data: UpdateBlacklistDto): Promise<Blacklist> => {
    const response = await api.put(`/blacklist/${id}`, data);
    return response.data.data;
  },

  // 블랙리스트 삭제
  delete: async (id: number): Promise<void> => {
    await api.delete(`/blacklist/${id}`);
  },

  // 블랙리스트 비활성화
  deactivate: async (id: number): Promise<Blacklist> => {
    const response = await api.put(`/blacklist/${id}/deactivate`);
    return response.data.data;
  },

  // 블랙리스트 활성화
  activate: async (id: number): Promise<Blacklist> => {
    const response = await api.put(`/blacklist/${id}/activate`);
    return response.data.data;
  },
};
